import { Component, OnInit, ViewChild } from '@angular/core';
import { DatePipe } from '@angular/common';
import * as CryptoJS from 'crypto-js';

import { CookieManagerService } from '../../../../../shared/services/cookie-manager.service';
import { DashboardService } from '../../../services/dashboard.service';
import { ReportsConstants } from '../../../../reports/reports.const';

import { Constants } from '../../../../../app.const';
import { WorkConstants } from "../../../../work/work.const";

declare var $: any;

@Component({
  selector: 'app-pending-puchin',
  templateUrl: './pending-puchin.component.html',
  styleUrls: ['./pending-puchin.component.css'],
  providers: [DashboardService]
})
export class PendingPuchinComponent implements OnInit {

  countOfholiday: number = 0;
  date: Date = new Date();
  label: string;
  leaveList: Array<any> = [];
  attendanceList: Array<any> = [];
  reportsConstants: any = ReportsConstants;

  private constants = Constants;

  constructor(
    private DashboardService: DashboardService,
    private datePipe: DatePipe,
  ) { }

  ngOnInit() {
    let $this = this;
    this.date = new Date();
    this.label = this.datePipe.transform(this.date, this.constants.dateFormat);
    this.getcountOfHoliday(this.datePipe.transform(this.date, this.constants.dateFormat), this.datePipe.transform(this.date, this.constants.dateFormat));
    this.checWidgetPermission();
  }

  getcountOfHoliday(startDate, endDate) {
    this.DashboardService.getHolidayList({ startDate, endDate }).subscribe(
      res => {
        this.countOfholiday = res.data.count;
        if (this.countOfholiday > 0) {
          $('#pending-punchin').hide();
          $('#emp-leave').hide();
        }
      }
    );
  }

  getPendingAttendanceAndLeave(startDate, endDate) {
    this.DashboardService.getPendingAttendanceAndLeave({ startDate, endDate }).subscribe(
      res => {
        this.leaveList = Object.keys(res.data.leave).map((key) => { return res.data.leave[key] });
        this.attendanceList = Object.keys(res.data.attendance).map((key) => { return res.data.attendance[key] });
      }
    );
  }

  checWidgetPermission() {
    if (this.date.getDay() == 0 || this.date.getDay() == 6) {
      $('#pending-punchin').hide();
      $('#emp-leave').hide();
    } else {
      // call method
      this.getPendingAttendanceAndLeave(this.datePipe.transform(this.date, this.constants.dateFormat),this.datePipe.transform(this.date, this.constants.dateFormat));
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/modules/dashboard/components/maindashboard/pending-puchin/pending-puchin.component.ts